import React, { useContext } from "react";
import { useNavigate, Redirect, Link } from "react-router-dom";
import { AppContext } from "../contexts/AppContext";
import moment from "moment";
import { AuthContext } from "../contexts/AuthContext";
import undrawProfile from "../img/undraw_profile.svg";

const JoinSession = ({ data }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const navigate = useNavigate();

  const startTimeMoment = moment(data?.start_time);
  const endTimeMoment = moment(data?.end_time);

  const formattedDate = startTimeMoment.format("Do MMMM");
  const formattedTime = `${startTimeMoment.format(
    "h:mmA"
  )} - ${endTimeMoment.format("h:mmA")}`;

  const cancelSessionHandler = () => {
    appContext.updateModalState();
    appContext.updateModalType("cancelSession", "Cancellation", data);
  };

  const rescheduleHandler = () => {
    appContext.updateModalState();
    appContext.updateModalType("rescheduleSession", "", data);
  };

  const navigateHandler = () => {
    // navigate(`../${data?.meetLink}`);
    appContext.updateModalState();
    window.location.href = data?.meetLink;
  };

  return (
    <div className="join-session-modal">
      <div className="modal-header">
        <h5
          className="modal-title"
          id="exampleModalLongTitle"
          onClick={() => {
            appContext.updateModalState();
            let redirectId =
              user?.userId && user?.userId === data?.mentor_id
                ? data?.mentee_user_name
                : user?.data?.data?.userId === data?.mentor_id
                ? data?.mentee_user_name
                : data?.mentor_user_name;
            navigate(`../${redirectId}`);
          }}
        >
          <img
            className="img-profile rounded-circle mr-3"
            src={
              user?.userId && user?.userId === data?.mentor_id
                ? data?.mentee_pic_url || undrawProfile
                : user?.data?.data?.userId === data?.mentor_id
                ? data?.mentee_pic_url || undrawProfile
                : data?.mentor_pic_url || undrawProfile
            }
          />

          <span className="ml-3 profile-name">
            {user?.userId && user?.userId === data?.mentor_id
              ? data?.mentee_name
              : user?.data?.data?.userId === data?.mentor_id
              ? data?.mentee_name
              : data?.mentor_name}
          </span>
        </h5>
      </div>
      <div className="modal-body">
        <h6 className="table-title">Booked</h6>
        <table className="ml-3">
          <tr className="">
            <td className="table-title mb-3">Title</td>
            <td>:</td>
            <td className="table-des">{data?.service_name}</td>
          </tr>
          <tr className="mb-3">
            <td className="table-title">Date</td>
            <td>:</td>
            <td className="table-des">{formattedDate}</td>
          </tr>
          <tr className="mb-3">
            <td className="table-title">Time</td>
            <td>:</td>
            <td className="table-des">{formattedTime}</td>
          </tr>
          <tr className="mb-3">
            <td className="table-title">Call</td>
            <td>:</td>
            <td className="table-des">
              {data?.appointment_type || "1:1 Call"}
            </td>
          </tr>
        </table>
        {data?.meetLink && (
          <div className="mt-4 ml-3">
            <button
              className="btn btn-primary btn-modal rounded-pill"
              data-toggle="modal"
              data-target="#session"
              data-dismiss="modal"
              onClick={navigateHandler}
            >
              Join Session
            </button>
          </div>
        )}
      </div>
      <div className="modal-footer session-footer mt-4">
        <p>
          Want to make a change?{" "}
          <span onClick={rescheduleHandler}>
            <a>Reschedule</a>
          </span>{" "}
          or{" "}
          <span onClick={cancelSessionHandler}>
            <a>Cancel Session</a>
          </span>
        </p>
      </div>
    </div>
  );
};

export default JoinSession;
